import { useState } from "react";
import { CronExpData } from "../components/data/CronExpData";
import ExpressionExplanation from "../components/elements/ExpressionExplanation";
const Home = () => {
  const [copyStatus, setCopyStatus] = useState(false);
  const [title, setTitle] = useState('Every minute');
  const [code, setCode] = useState('* * * * *');
  const [details, setDetails] = useState('Every minute');
  return (
    <>
      <section className="section section-cron-expression">
        <h3 className="text-center">{ title }</h3>
        <div className='flex-center copy-message'>
          {copyStatus ? <div className='success'>copied..</div> : <div className='copy'>Click the expression below to copy</div>}
        </div>
        <div className="code" onClick={() => {
          navigator.clipboard.writeText(`${code}`);
          setCopyStatus(true);
        }}>
          {code}
        </div>
        <h3 className="text-center">{details}</h3>
      </section>
      <section className="section">
        <h2 className="text-center">Select Cron Expressions</h2>
        <div className="common-expression-list">
          {CronExpData.map((i) =>
            <div key={i.id} className='common-expression-list-item' onClick={() => {
              setCode(i.code);
              setTitle(i.title);
              setDetails(i.details);
              setCopyStatus(false);
            }}>
              {i.title}
            </div>
          )}
        </div>
      </section>
      <ExpressionExplanation />
    </>
  )
}
export default Home;